export default function WalletIcon() {
  return (
    <>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.125 5.20166V15.2017C3.125 15.5332 3.2567 15.8511 3.49112 16.0855C3.72554 16.32 4.04348 16.4517 4.375 16.4517H16.875C17.0408 16.4517 17.1997 16.3858 17.3169 16.2686C17.4342 16.1514 17.5 15.9924 17.5 15.8267V7.07666C17.5 6.9109 17.4342 6.75193 17.3169 6.63472C17.1997 6.51751 17.0408 6.45166 16.875 6.45166H4.375C4.04348 6.45166 3.72554 6.31996 3.49112 6.08554C3.2567 5.85112 3.125 5.53318 3.125 5.20166ZM3.125 5.20166C3.125 4.87014 3.2567 4.5522 3.49112 4.31778C3.72554 4.08336 4.04348 3.95166 4.375 3.95166H15"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.0625 12.3892C14.5803 12.3892 15 11.9694 15 11.4517C15 10.9339 14.5803 10.5142 14.0625 10.5142C13.5447 10.5142 13.125 10.9339 13.125 11.4517C13.125 11.9694 13.5447 12.3892 14.0625 12.3892Z"
          fill="currentColor"
        />
      </svg>
    </>
  );
}
